import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home"),
  },
  {
    path: "/game",
    name: "game",
    component: () => import("../views/Game"),
  },
  {
    path: "/else",
    name: "else",
    component: () => import("../views/Game/else.vue"),
  },
  {
    path: "/fullscreen",
    name: "fullscreen",
    component: () => import("../views/Game/fullscreen.vue"),
  },
  {
    path: "/rom",
    name: "rom",
    component: () => import("../views/Game/rom.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
